export default __webpack_public_path__ + "static/media/driver.caf87c71.jpg";